var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimtracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64.5 75.4",
    style: {
      enableBackground: "new 0 0 64.5 75.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M49.7,14.7l-15-12.4c-0.9-0.7-1.9-1.1-3-1.1H10.7C5.9,1.2,2,5.1,2,9.7v55.8c0,4.7,3.9,8.5,8.7,8.5h23.1 c-2.7-1.9-5-4.5-6.5-7.5h-2.4V55h0.3c0-0.4,0.1-0.7,0.2-1.1h-4.7c-0.1,0-0.3-0.1-0.3-0.2V46c0-0.2,0.2-0.2,0.3-0.2h7.5 c0.1,0,0.2,0.1,0.3,0.2c1.3-2,2.9-3.7,4.7-5.1v-7.7h1.2c2.1,0,3.9,1.8,3.9,3.9v0.9c2.3-0.9,4.9-1.4,7.5-1.4c1.9,0,3.7,0.2,5.4,0.7 V17.9C51.2,16.6,50.6,15.5,49.7,14.7z M9.5,37c0-2.1,1.8-3.9,3.9-3.9h2.3v8.1l3.6,3.6v4.5H9.5V37z M15.7,66.5h-2.4 c-2.1,0-3.9-1.8-3.9-3.9V50.3h9.8v4.5l-3.6,3.6V66.5z M24,55v11.6h-7.3v-7.8l3.7-3.7H24z M24,44.6h-3.6l-3.7-3.8v-7.7H24V44.6z  M32.3,40.8l-3.8,3.8h-3.6V33.2h7.4V40.8z"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.4,55.2c-0.8-6.2-5.7-11.1-11.9-11.9v-3.8h-3.6v3.8C37.7,44.1,32.8,49,32,55.2h-3.9v3.6H32c0.8,6.2,5.7,11.1,11.9,11.9 v3.9h3.6v-3.9c6.2-0.8,11.1-5.7,11.9-11.9h3.9v-3.6H59.4z M45.7,67.5c-5.8,0-10.5-4.7-10.5-10.5c0-5.8,4.7-10.5,10.5-10.5 c5.8,0,10.5,4.7,10.5,10.5C56.3,62.8,51.5,67.5,45.7,67.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimtracking);
export default __webpack_public_path__ + "static/media/sim tracking.0b538b15509f9173fb9bf3e14c7dfae6.svg";
export { ForwardRef as ReactComponent };